import { ReactNode } from 'react';

import './Stack.scss';

type Props = {
  alignment?: 'start' | 'center' | 'end';
  className?: string;
  children: ReactNode;
};

export function Stack(props: Props) {
  const { alignment = 'start', className = '' } = props;

  return <div className={`Stack Stack--align-${alignment} ${className}`}>{props.children}</div>;
}
